/**
 * Tom / Hilfe: OpenAI TTS-Parameter (Frontend .env: VITE_TOM_TTS_MODEL, VITE_TOM_TTS_VOICE).
 * Backend /tts validiert und kann TOM_TTS_* als Fallback nutzen.
 */
export function tomTtsModel(): string {
  const m = (import.meta.env.VITE_TOM_TTS_MODEL || 'tts-1').trim();
  return m || 'tts-1';
}

export function tomTtsVoice(): string {
  const v = (import.meta.env.VITE_TOM_TTS_VOICE || 'fable').trim();
  return v || 'fable';
}
